var exports = {
  "kL": "x112a1f60--90e7b5--container",
  "Kk": "x112a1f60--90e7b5--icon",
  "Pf": "x112a1f60--90e7b5--label",
};

module.exports = exports;
